import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map } from 'rxjs';

export const featureGuard: CanActivateFn = (route) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const featureId = route.data['featureId'] as string | undefined;

  // If no featureId is specified in route data, allow access
  if (!featureId) {
    return true;
  }

  const isLoading$ = toObservable(tenantService.isLoading);

  return isLoading$.pipe(
    filter(isLoading => !isLoading),
    take(1),
    map(() => {
      const error = tenantService.error();
      if (error !== null) {
        snackBar.open(error || 'テナント情報の取得に失敗しました', '閉じる', { duration: 3000 });
        return router.createUrlTree(['/']);
      }

      if (tenantService.hasFeature(featureId)) {
        return true;
      } else {
        snackBar.open('この機能はご利用いただけません', '閉じる', { duration: 3000 });
        return router.createUrlTree(['/']);
      }
    })
  );
};
